import { isRKHYAPP, isHZWAPP, isMmz } from '@/utils'
import qs from 'query-string'

const channelIdList = [
  10121110, 10121111, 10121112, 10121115, 10111018, 10112110, 10112111,
  10112112, 10112113, 10112114, 10112115, 10112116, 10112210, 10112211
] // 需要自动收集表单页面channelId集合

export const channelIdIsSendForm = level4CategoryId =>
  channelIdList.includes(level4CategoryId)

/** 商详展示分享赚信息
 *  1. 人客合一环境展示
 *  2. 非人客环境 从成长加合伙人分享赚入口进入
 */
export const showShareEarnInProductDetail = () => {
  const url = qs.parse(window.location.search)
  return (
    isRKHYAPP() || isMmz() || (url.shareEarn && !url.chansource && isHZWAPP())
  )
}

//删除url中某个参数
export const delUrl = (loca, name) => {
  let baseUrl = ''
  if (loca.indexOf('&') > -1) {
    baseUrl = loca.split('?')[0] + '?'
  } else {
    baseUrl = loca.split('?')[0]
  }
  let query = loca.split('?')[1]
  if (query && query.indexOf(name) > -1) {
    var obj = {}
    var arr = query.split('&')
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split('=')
      obj[arr[i][0]] = arr[i][1]
    }
    delete obj[name]
    var url =
      baseUrl +
      JSON.stringify(obj)
        .replace(/[\"\{\}]/g, '')
        .replace(/\:/g, '=')
        .replace(/\,/g, '&')
    return url
  } else {
    return loca
  }
}
